/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('SaleService_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceSaleS = $resource(baseUrl + 'rest/saleServices/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
        return resourceSaleS;
    }
    ]);

angular.module('FlexyBeautyApp.services').
factory('SaleService',["SaleService_Resource","CategoryData","ServiceData","SaleServiceData","HumanResourceData","TaxMode","SaleItem","Category","Service","TypeOfSale",
        function (SaleService_Resource,CategoryData,ServiceData,SaleServiceData,HumanResourceData,TaxMode,SaleItem,Category,Service,TypeOfSale) {
    //SaleService inherit from Activity
        var  SaleService = function (saleServiceRes,isPreviousVersion,parentSaleService)
        {
            SaleItem.call(this);

            this.id = null;
            this.label = null;
            this.price = 0;
            this.vat = null;
            this.vatCode = null;
            this.quantity = 0;
            this.originalPrice = 0;
            this.discountPercent = 0;
            this.service = null;
            this.sale = null;
            this.humanResource = null;
            this.version = null;
            this.subSaleServices = [];
            if(parentSaleService!==undefined && parentSaleService!=null)
                this.parentSaleService = parentSaleService;
            else
                this.parentSaleService = null;

            this.loadObject(saleServiceRes)
            this.loadRef();
            if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
                SaleServiceData.add(this);
        };

        SaleService.prototype = Object.create(SaleItem.prototype);//inherit functions from SaleItem

        SaleService.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id=object.id;
                this.label=object.label;
                this.price=object.price;
                this.vat=object.vat;
                this.vatCode=object.vatCode;
                if (object.originalPrice!==undefined && object.originalPrice)
                    this.originalPrice=object.originalPrice;
                else
                    this.originalPrice=object.price;
                this.discountPercent=object.discountPercent;
                this.quantity=object.quantity;
                this.serviceId=object.serviceId;
                if (object.humanResourceId)
                    this.humanResource = HumanResourceData.getById(object.humanResourceId);
                if (object.version)
                    this.version = object.version;

                this.subSaleServices = [];
                if (object.subSaleServices)
                {
                    for (var j=0;j< object.subSaleServices.length;j++)
                    {
                        var saleService = new SaleService(object.subSaleServices[j], null, this);
                        this.subSaleServices.push(saleService);
                    }
                }
            }
        };

        SaleService.prototype.loadRef = function()
        {
            if (this.serviceId)
                this.service = ServiceData.getById(this.serviceId);
            for (var i = 0; i < this.subSaleServices.length;i++)
                this.subSaleServices[i].service = ServiceData.getById(this.subSaleServices[i].serviceId);
        };

        SaleService.prototype.copyDataTo = function(object)
        {
            object.id=this.id;
            object.label=this.label;
            object.price=this.price;
            object.vat=this.vat;
            object.vatCode=this.vatCode;
            object.originalPrice=this.originalPrice;
            object.discountPercent=this.discountPercent;
            object.quantity=this.quantity;
            if (this.humanResource)
                object.humanResourceId = this.humanResource.id;

            if (this.service)
                object.serviceId = this.service.id;
            else
                object.serviceId = null;

            if (this.sale)
                object.saleId = this.sale.id;
            else
                object.saleId = null;

            object.subSaleServices = [];
            for (var i = 0;i < this.subSaleServices.length; i++)
                object.subSaleServices.push(this.subSaleServices[i].getObjectResource(true));
        };
        SaleService.prototype.getObjectResource = function()
        {
            var saleServiceRes = new SaleService_Resource();
            this.copyDataTo(saleServiceRes);
            return saleServiceRes;
        };
        SaleService.prototype.setIdUsingObject = function(object)
        {
            this.id = object.id;
        };
        SaleService.prototype.setId = function(id)
        {
            this.id = id;
        };
        SaleService.prototype.setService = function(service)
        {
            this.service = service;
        };
        SaleService.prototype.getService = function()
        {
            return this.service;
        };
        SaleService.prototype.getItem = function()
        {
            return this.service;
        };
        SaleService.prototype.getItemCategoryType = function()
        {
            return Category;
        };
        SaleService.prototype.getItemType = function()
        {
            return Service;
        };

        SaleService.prototype.getParentItem = function() {
            return this.parentSaleService ? this.parentSaleService.getItem() : null;
        };

        SaleService.prototype.getId = function()
        {
            return this.id;
        };
        SaleService.prototype.getLabel = function()
        {
            return this.label;
        };
        SaleService.prototype.getPrice = function()
        {
            return this.price;
        };
        SaleService.prototype.getDiscountPrice = function(taxMode)
        {
            let price = 0;

            if (this.getSale().isStatusSoldOrCreditOrCanceled()) {
                if(this.isPriceCalculatedBySubSaleServices()) {
                    for(let i = 0; i < this.subSaleServices.length; i++) {
                        price += this.subSaleServices[i].price;
                    }
                } else {
                    price = this.price;
                }

                //apply global discount on price
                if (this.getSale().discountPercent !== 0) {
                    price -= this.getSale().discountPercent * price / 100;
                }
                if(taxMode === TaxMode.HT) {
                    let vat = this.vat?this.vat:this.getSale().vat;
                    price = price / (100 + vat) * 100;
                }
            }

            return price;
        };

        /**
         * @override SaleItem.prototype.getSale
         */
        SaleService.prototype.getSale = function()
        {
            if(this.parentSaleService)
                return this.parentSaleService.getSale();
            else
                return this.sale;
        };

        SaleService.prototype.getBookingService = function()
        {
            var booking = this.getSale().booking,
                bookingService = null,
                bookingServiceFound = false;
            if(booking){
                for(var i = 0; i < booking.bookingServices.length; i++) {
                    if (booking.bookingServices[i].service == this.service) {
                        bookingService = booking.bookingServices[i];
                        bookingServiceFound = true;
                    }
                    for(var j = 0; j < booking.bookingServices[i].subBookingServices.length; j++) {
                        if (booking.bookingServices[i].subBookingServices[j].service == this.service) {
                            bookingService = booking.bookingServices[i].subBookingServices[j];
                            bookingServiceFound = true;
                            break;
                        }
                    }
                    if(bookingServiceFound){
                        break;
                    }
                }
            }
            return bookingService;
        };

        /**
         * @override SaleItem.prototype.getDuration
         */
        SaleService.prototype.getDuration = function()
        {
            var duration = 0;

            if(this.subSaleServices.length != 0){
                for(var i = 0; i < this.subSaleServices.length; i++){
                    if(this.subSaleServices[i].humanResource){
                        duration += this.subSaleServices[i].getDuration();
                    }
                }
            }
            else{
                var bookingService = this.getBookingService();
                if(bookingService) {
                    duration = bookingService.period.duration;
                }
                else{
                    if(this.service) {
                        duration = this.service.duration;
                    }
                }
            }
            return duration;
        };

        /**
         * @override SaleItem.prototype.matchSpecificMatchingOfItem
         */
        SaleService.prototype.matchSpecificMatchingOfItem = function(saleObject){
            let matchSpecificMatchingOfItem = false;
            if((saleObject === TypeOfSale.ALL_WITH_PRODUCT_OR_NOT ) ||
               (saleObject === TypeOfSale.SERVICE_AND_PRODUCT && this.getSale().saleProducts.length > 0) ||
               (saleObject === TypeOfSale.SERVICE_WITHOUT_PRODUCT && this.getSale().saleProducts.length == 0)) {
                matchSpecificMatchingOfItem = true;
            }
            return matchSpecificMatchingOfItem;
        };

        /**
         * @override SaleItem.prototype.incrementSalesDatasForSubSales
         */
        SaleService.prototype.incrementSalesDatasForSubSales = function(salesData, firstDayOfPeriod, lastDayOfPeriod){
            if(this.parentSaleService){
               if(salesData.subSales.indexOf(this.parentSaleService) === -1) {
                   salesData.subSales.push(this.parentSaleService);
                   salesData.qteSubSales += this.getStatQuantity();
               }

                if(!this.getSale().booking && salesData.subSalesWithoutBooking.indexOf(this.parentSaleService) === -1){
                    salesData.subSalesWithoutBooking.push(this.parentSaleService);
                    salesData.qteSubSalesWithoutBooking += this.getStatQuantity();
                }
                if(salesData.subSalesWithBookingOutOfPeriod.indexOf(this.parentSaleService) === -1 && this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id)){
                    salesData.subSalesWithBookingOutOfPeriod.push(this.parentSaleService);
                    salesData.qteSubSalesWithBookingOutOfPeriod  += (this.getSale().status == 'credit' ? -1 : 1);
                }
            }
            else if(!this.parentSaleService){
                if(salesData.subSales.indexOf(this) === -1) {
                    salesData.subSales.push(this);
                    salesData.qteSubSales += this.getStatQuantity();
                }
                if(!this.getSale().booking && salesData.subSalesWithoutBooking.indexOf(this) === -1){
                    salesData.subSalesWithoutBooking.push(this);
                    salesData.qteSubSalesWithoutBooking += this.getStatQuantity();
                }
                if(salesData.subSalesWithBookingOutOfPeriod.indexOf(this) === -1 && this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id)){
                    salesData.subSalesWithBookingOutOfPeriod.push(this);
                    salesData.qteSubSalesWithBookingOutOfPeriod  += this.getStatQuantity();
                }
            }
        };

        /**
         * @override SaleItem.prototype.incrementSalesDatasForOldAndNewCustomer
         */
        SaleService.prototype.incrementSalesDatasForOldAndNewCustomer = function(salesData, firstDayOfPeriod){
            if (this.getSale().customer && (this.getSale().customer.hasSaleBefore(firstDayOfPeriod) || this.getSale().customer.hasBookingBefore(firstDayOfPeriod))) {
                if(this.parentSaleService && salesData.subSalesOldCustomer.indexOf(this.parentSaleService) === -1){
                    salesData.subSalesOldCustomer.push(this.parentSaleService);
                    salesData.qteSubSalesOldCustomer += this.parentSaleService.getStatQuantity();
                }
                else if(!this.parentSaleService && salesData.subSalesOldCustomer.indexOf(this) === -1){
                    salesData.subSalesOldCustomer.push(this);
                    salesData.qteSubSalesOldCustomer += this.getStatQuantity();
                }

                if(salesData.salesOldCustomer.indexOf(this.getSale()) === -1) {
                    salesData.salesOldCustomer.push(this.getSale());
                }
            }
            else {
                if(this.parentSaleService && salesData.subSalesNewCustomer.indexOf(this.parentSaleService) === -1){
                    salesData.subSalesNewCustomer.push(this.parentSaleService);
                    salesData.qteSubSalesNewCustomer += this.parentSaleService.getStatQuantity();
                }
                else if(!this.parentSaleService && salesData.subSalesNewCustomer.indexOf(this) === -1){
                    salesData.subSalesNewCustomer.push(this);
                    salesData.qteSubSalesNewCustomer += this.getStatQuantity();
                }

                if(salesData.salesNewCustomer.indexOf(this.getSale()) === -1) {
                    salesData.salesNewCustomer.push(this.getSale());
                }
            }
        };

        SaleService.prototype.isPriceCalculatedBySubSaleServices = function() {
            let isTurnoverFromSubSaleServices = true;
            if(this.subSaleServices == null || this.subSaleServices.length === 0) {
                isTurnoverFromSubSaleServices = false;
            } else {
                let totalPriceFromSubSaleServices = 0;
                let totalDiscountFromSubSaleServices = 0;
                for(let i = 0; i < this.subSaleServices.length; i++) {
                    totalPriceFromSubSaleServices += this.subSaleServices[i].price;
                    totalDiscountFromSubSaleServices += this.subSaleServices[i].originalPrice - this.subSaleServices[i].price;
                }

                let roundedPriceFromSaleService = Math.round(this.price * 100) / 100;
                let roundedDiscountFromSaleService = Math.round((this.originalPrice - this.price) * 100) / 100;
                let roundedPriceFromSubSaleServices = Math.round(totalPriceFromSubSaleServices * 100) / 100;
                let roundedDiscountFromSubSaleServices = Math.round(totalDiscountFromSubSaleServices * 100) / 100;
                let diffPrice = Math.abs(roundedPriceFromSaleService - roundedPriceFromSubSaleServices);
                let diffDiscount = Math.abs(roundedDiscountFromSaleService - roundedDiscountFromSubSaleServices);

                if((roundedPriceFromSubSaleServices === 0 && roundedPriceFromSaleService !== 0)
                    || diffPrice > 0.01 && diffDiscount > 0.01) {
                    isTurnoverFromSubSaleServices = false
                }
            }
            return isTurnoverFromSubSaleServices;
        };

        return SaleService;
    }
]);

angular.module('FlexyBeautyApp.services').
    factory('SaleServiceSrv',["$log","ServerSrv","DayData","SaleServiceData","SaleService","WorkingPeriodDayHrData","DayHrData","ActivitySrv","SaleData",
        function ($log,ServerSrv,DayData,SaleServiceData,SaleService,WorkingPeriodDayHrData,DayHrData,ActivitySrv,SaleData)
    {
        var  ssSrv = {};

        ssSrv.save =  function(saleService,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(ssSrv.saveSync, saleService, successFunction, errorFunction);
        };
        ssSrv.saveSync =  function(saleService,successFunction,errorFunction)
        {
            var bsRes = saleService.getObjectResource();
            bsRes.$save({}, //no params
                function (data) {
                    try {
                        // now we can set the id
                        saleService.setId(data.id);
                        if (!saleService.version || (data.version && data.version > saleService.version))
                            saleService.version = data.version;
                        if (data.subSaleServicesId)
                            for (var j = 0; j < data.subSaleServicesId.length;j++) {
                                saleService.subSaleServices[j].setId(data.subSaleServicesId[j]);
                            }

                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        ssSrv.updateLocally =  function(id,resource)
        {
            var saleService =  SaleServiceData.getById(id);

            if (saleService && saleService.version && resource.version && resource.version < saleService.version)
                return null;

            if (saleService!=null)
            {
                saleService.loadObject(resource);
                saleService.id = id;
                //remove from sale
                if(saleService.sale)
                    saleService.sale.removeSaleService(saleService);

                if(resource.saleId)
                {
                    var sale = SaleData.getById(resource.saleId);
                    if (sale)
                        sale.addSaleService(saleService);
                }
            }

            return saleService;

        };
        ssSrv.removeLocally =  function(id,resource)
        {
            var saleService =  SaleServiceData.getById(id)
            if (saleService && saleService.version && resource.version && resource.version < saleService.version)
                return null;
            if (saleService!=null)
            {
            }
            return saleService;
        };
        ssSrv.addLocally =  function(id,resource)
        {
            var saleService =  SaleServiceData.getById(id)
            if (saleService && saleService.version && resource.version && resource.version < saleService.version)
                return null;
            if (saleService!=null) //check if resource already exist inside index (current action could be a 'cancel')
                saleService.loadObject(resource);
            else
            {
                saleService = new SaleService(resource);
            }
            saleService.id = id;
            //add to sale
            if(resource.saleId)
            {
                var sale = SaleData.getById(resource.saleId);
                if (sale)
                    sale.addSaleService(saleService);
            }

            return saleService;
        };
        ssSrv.getPreviousVersionInstance =  function(resource)
        {
            var saleService =  new SaleService(resource,true);
            if(resource.saleId)
                saleService.sale = SaleData.getById(resource.saleId);
            return saleService;

        };

        return ssSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SaleServiceData',["$log", function ($log)
    {
        var  saleServiceData =
        {
            indexSaleServices : []
        };
        saleServiceData.getById =  function(saleServiceId)
        {
            for (var i=0;i<this.indexSaleServices.length;i++)
                if (this.indexSaleServices[i].id==saleServiceId)
                    return this.indexSaleServices[i];
            return null;
        }
        saleServiceData.getIndexOf =  function(saleService)
        {
            if (saleService)
                return this.indexSaleServices.indexOf(saleService);
            return -1;
        }
        saleServiceData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexSaleServices.length)
                return this.indexSaleServices[index];
            else
                return null;
        }
        saleServiceData.add =  function(saleService)
        {
            this.indexSaleServices.push(saleService);
            return this.indexSaleServices.length-1;
        }
        saleServiceData.clear =  function()
        {
            saleServiceData.indexSaleServices = [];
        }


        return saleServiceData;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/SaleService.js